import { render } from "./alertDialog.vue?vue&type=template&id=a1913c10"
import script from "./alertDialog.vue?vue&type=script&lang=js"
export * from "./alertDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__